module.exports = __webpack_public_path__ + "img/fr.cc4d943d.svg";